import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { from, map } from 'rxjs';
import { AppLocale, LocaleService } from '../services/locale.service';

/**
 * Garde appliquée à chaque sous-arbre de langue (`/fr`, `/en`). Active la
 * langue portée par `route.data.locale` AVANT le rendu des composants enfants.
 * Renvoie un Observable<true> qui n'émet qu'une fois le fichier de langue
 * chargé, ce qui garantit un premier rendu (SSR inclus) déjà traduit.
 *
 * Ne se ré-exécute que lorsqu'on change de préfixe de langue : la navigation
 * entre pages d'une même langue ne recharge rien.
 */
export const localeGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const localeService = inject(LocaleService);
  const locale = route.data['locale'] as AppLocale;
  return from(localeService.applyFromUrl(locale)).pipe(map(() => true));
};
